import { ApiError, NetworkError, isNetworkError } from '../../../shared/api/client';

/** Русские тексты ошибок для списков, редактора и мутаций. */
export function describeTaskError(error: unknown): string {
  if (error instanceof ApiError && error.status === 401) {
    return 'Сессия истекла. Войдите снова.';
  }
  if (error instanceof ApiError) {
    return error.message.length > 0 ? error.message : 'Ошибка сервера. Попробуйте позже.';
  }
  if (isNetworkError(error) || error instanceof NetworkError) {
    return 'Нет соединения с сервером. Изменение сохранится на устройстве и уйдёт позже.';
  }
  if (error instanceof Error && error.message.trim().length > 0) {
    return error.message;
  }
  return 'Не удалось выполнить действие.';
}

export function isSessionError(error: unknown): boolean {
  return error instanceof ApiError && error.status === 401;
}
